/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Model from 'flarum/common/Model';
import FakeDiscussion from './FakeDiscussion';

export default class UserAchievement extends Model {
	id = Model.attribute('id');
	assignedAt = Model.attribute('assignedAt');

	user = Model.hasOne('user');
	achievement = Model.hasOne('achievement');
	achievementLevel = Model.hasOne('achievementLevel');

	// Add a fake discussion relationship, used to group notifications!
	discussion() {
		return new FakeDiscussion();
	}
}
